/*eslint-disable */
import appFooter from '@/components/footer/index';
import contestPopup from '@/components/quiz-contest-popup/index';
import covidPopup from '@/components/covid-19-popup';
import countries from '@/services/country.json';
import {
  bus
} from '@/main';
import homeMedia from './home-media';
import {
  mapGetters
} from 'vuex';
var $ = window.jQuery = require('jquery');
import carousel from 'vue-owl-carousel'
import Vue from 'vue'

import 'fullpage-vue/src/fullpage.css'
import VueFullpage from 'fullpage-vue'
Vue.use(VueFullpage)
// Multi Color Bg Img Of Section
import variation_random_img1 from './../../assets/images/random_img/oddnary-variation-5.jpg';
import variation_random_img2 from './../../assets/images/random_img/oddnary-variation-7.jpg';
import variation_random_img3 from './../../assets/images/random_img/oddnary-variation-1.jpg';
import variation_random_img4 from './../../assets/images/random_img/oddnary-variation-4.jpg';
import variation_random_img5 from './../../assets/images/random_img/oddnary-variation-2.jpg';
import variation_random_img6 from './../../assets/images/random_img/oddnary-variation-6.jpg';
var actvSlide, actvDots, overFlowVis, beforeLineActv, actvAlertPopup, actvAlertTopLine;
var topBannerSlide, topBannerSlide1, topBannerSlide2, topBannerSlide3, topBannerSlide4, topBannerSlide5;
export default {
  name: 'home',
  components: {
    carousel,
    'app-footer': appFooter,
    homeMedia,
    'contest-popup':contestPopup,
    'covid-popup' : covidPopup,
  },
  props:[],
  data() {
    return {
      currentView: '',
      isLeaderBoardDone: false,
      imageIndex: 0,
      images: [],
      variationImages: [],
      quizBannerData: {},
      popupOverlay: false,
      publicCourses: [],
      courseCategory: {},
      categorythumbnail: '',
      courseCategoryName: '',
      scrollingSection: '',
      preloader: true,
      extralargeSliderWrapper: false,
      extralargeWrapperScreen: Boolean,
      homewrpscreen:Boolean,
      window: {
        width: 0,
        height: 0
      },
      status: null,
      contestPopup:false,
      rankHolderDetails:false,
      loggedinLinkHide:true,
      getPubLeaderboardDetails:{},
      countryList: [],
      opts: {
        start: 0,
        dir: 'v',
        duration: 500,
        loop:false,
        overflow:'auto',
        movingFlag:Boolean,
        beforeChange: function (currentSlideEl,currenIndex,nextIndex) {
          // console.log(currenIndex)
          if(nextIndex == 1){
            $('.second_banner').removeClass('d-none');
            $(".first_banner .explore_btn").addClass('actv_explore')
            $('.footer_wrp').addClass('d-none');
          }
          if(nextIndex == 2){
            $('.third_banner').removeClass('d-none');
            $(".second_banner .explore_btn").addClass('actv_explore')
            $('.home-testimonial .VueCarousel-inner').css('display', 'flex')
            $('body').addClass('final_slide')
            $('body.final_slide').mCustomScrollbar({
              theme:"inset-3-dark",
              contentTouchScroll:25,
              keyboard:{ scrollType: "stepless" }
              })
          }
        },
        afterChange: function (currentSlideEl,currenIndex) {
          if(currenIndex == 0){
            $(".first_banner .explore_btn").removeClass('actv_explore')
            $('.home-testimonial .VueCarousel-inner').css('display', 'none')
          }
          if(currenIndex == 1){
            $("body").removeClass('contest_popup_active')
            $(".second_banner .explore_btn").removeClass('actv_explore')
            $(".quiz_contest_popup").removeClass('actv_contest')
            $(".quiz_contest_popup_wrp").removeClass('actv_contest_popup')
          }
          if(currenIndex == 2){
            $('.footer_wrp').removeClass('d-none');
            $(".quiz_contest_popup").removeClass('actv_contest')
            $(".quiz_contest_popup_wrp").removeClass('actv_contest_popup')
          }
        }
      }
    }
  },
  // Override the meta.
  metaInfo: {
    meta: [{
      name: 'description',
      content: 'ODDVEGA is a social learning ecosystem that is powered by AI algorithms and that combines e-learning, social media, gamification and e-commerce to create a unique experience where all learning, educational and constructive social activities are incentivized and tangibly rewarded. ODDVEGA’s learning core, powered by AI and machine learning, helps users focus on educational and social activities that are fun filled, materially rewarding and best suited for them given their skills, needs, interests and knowledge base. ODDVEGA makes learning a social activity that is both fun-filled and highly rewarding at the same time for everyone.'
    }]
  },
  computed: {
    ...mapGetters([
      'getCourseCategoryGetter',
      'getQuizBannerGetter',
      'publicLeaderboardGetters'
    ]),
    getCategory() {
      this.$store.dispatch('getCourseCategory')
        .then(res => {
          this.courseCategory = this.$store.getters.getCourseCategoryGetter.data;
          if (this.courseCategory.length >= 5) {
            this.extralargeSliderWrapper = true;
          }
        })
        .catch(err => {})
    },
    getQuizBanner() {
      this.$store.dispatch('getQuizBannerData')
        .then(res => {
          this.quizBannerData = this.$store.getters.getQuizBannerGetter.data.results;
        })
        .catch(err => {})
    },
    getCatgoryThumbnail(value) {
      if (value == 'Machine Learning') {
        return './../../assets/images/course_img1.jpg'
      }
    },
  },
  mounted() {
    $(window).scrollTop(0)
    // Show Header Buttons
    bus.$emit('hideHeaderbtn', true);
    bus.$emit('showLoginbtn', true);
    bus.$emit('showRegisterbtn', true);
    bus.$emit('showHomeMenuBtn', false);
    bus.$emit('showQuizMenubtn', true);
    bus.$emit('showMyProfileMenu', true);
    $(document).ready(function() {
      $('.second_banner').show()
      $('footer').addClass('d-none');
      $(".first_banner .explore_btn > a").on('click', function(event) {
        $('.second_banner').removeClass("d-none");
        $('.second_banner').show
        event.preventDefault();
        //calculate destination place
        var dest = 0;
        if ($(".first_banner .explore_btn > a").offset().top > $(document).height() - $(window).height()) {
          dest = $(document).height() - $(window).height();
        } else {
          dest = $(".first_banner .explore_btn > a").offset().top;
          setTimeout(function(){
            $(".first_banner .explore_btn").addClass('actv_explore')
          }, 1000)
        }
        //go to destination
        $('html,body').animate({
          scrollTop: (dest) + 35
        }, 1000, 'swing');
        $('.scroll_hide').addClass('enabled');
      });
      $(".second_banner .explore_btn > a").click(function(event) {
        $('.third_banner').removeClass("d-none");
        event.preventDefault();
        //calculate destination place
        var dest = 0;
        if ($(".second_banner .explore_btn > a").offset().top > $(document).height() - $(window).height()) {
          dest = $(document).height() - $(window).height();
        } else {
          dest = $(".second_banner .explore_btn > a").offset().top;
          setTimeout(function(){
            $(".second_banner .explore_btn").addClass('actv_explore')
          }, 1000)
        }
        //go to destination
        $('html,body').animate({
          scrollTop: (dest) + 35
        }, 1000, 'swing');
        $(".footer_wrp").removeClass("d-none");
      });
    })
    setTimeout(() => {
      if(localStorage.getItem('Explore_Course')){
        this.moveNext()
        var _self =  this
        _self.opts.movingFlag = false
        // console.log(_self.opts.movingFlag, "Moving Flag false")
        localStorage.removeItem('Explore_Course')
      }
      bus.$on('covidMovingFlag', (data) => {
        var _self =  this
        _self.opts.movingFlag = data
      })
    }, 100)
    $('.app-loader.global').show()
    this.getCategory
    this.getQuizBanner
    this.randomImgLoaded()
    if (process.env.NODE_ENV == 'production') {
      this.$scriptLoader.load("https://www.googletagmanager.com/gtag/js?id=UA-152519411-1")
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'UA-152519411-1');
    }

    // Quiz Contest Popup JS
      $('.quiz_contest_alert_inner').slideUp()
      $('.quiz_contest_btn_wrp').removeClass('active_slide')
      $('.quiz_contest_dots').removeClass('active_dots')
      $('.quiz_contest_btn_txt').removeClass('overflow_vis')
      $('.quiz_contest_alert_before_line').removeClass('quiz_contest_alert_before_line_act')
      actvSlide = setTimeout(() => {
        $('.quiz_contest_btn_wrp').addClass('active_slide')
      }, 2800);
      actvDots = setTimeout(() => {
        $('.quiz_contest_dots').addClass('active_dots')
      },6200);
      overFlowVis = setTimeout(() => {
        $('.quiz_contest_btn_txt').addClass('overflow_vis')
      },6000);
      beforeLineActv = setTimeout(() => {
        $('.quiz_contest_alert_before_line').addClass('quiz_contest_alert_before_line_act')
      },7000);
      actvAlertPopup = setTimeout(() => {
        $('.quiz_contest_alert_inner').slideDown(1000)
      actvAlertTopLine = setTimeout(()=>{
          $('.quiz_contest_alert_popup').addClass('active_contest_alert_popup')
        },1600)
      }, 7000);
      $('.quiz_start_popup').click(function(event){
          setTimeout(()=>{
            $(".quiz_contest_popup").addClass('actv_contest')
          $("body").addClass('contest_popup_active')
          setTimeout(()=>{
            $(".quiz_contest_popup_wrp").addClass('actv_contest_popup')
          },100)
          },5)
      })
      $(document).click(function(event) {
        if (!$(event.target).closest(".quiz_start_popup, .quiz_contest_popup").length) {
          $("body").removeClass('contest_popup_active')
          $(".quiz_contest_popup").removeClass('actv_contest')
          $(".quiz_contest_popup_wrp").removeClass('actv_contest_popup')
        }
      });
      $(document).on('click', '.contest_home_icon', function(){
        $("body").removeClass('contest_popup_active')
        $(".quiz_contest_popup").removeClass('actv_contest')
        $(".quiz_contest_popup_wrp").removeClass('actv_contest_popup')
      });
      window.addEventListener('keyup', function(event) {
        // If  ESC key was pressed...
        if (event.keyCode === 27) {
          $("body").removeClass('contest_popup_active')
          $(".quiz_contest_popup").removeClass('actv_contest')
          $(".quiz_contest_popup_wrp").removeClass('actv_contest_popup')
        }
    });

    // Top Rank Holder Button Animation
    Object.keys(countries).map((key, index) => {
      this.countryList.push({
        name: countries[key].toLowerCase(),
        value: key.toLowerCase()
      })
    });
    $(document).ready(function(){
      topBannerSlide = setTimeout(() => {
        $('.top_rank_holder').addClass('actv_top_rank_animation')
      }, 1600);
      topBannerSlide1 = setTimeout(()=>{
          $('.top_rank_holder_animation_btn').addClass('rank_holder_l_aniation_start')
      },4400)
      topBannerSlide2 = setTimeout(()=>{
          $('.top_rank_holder').addClass('rank_holder_l_aniation_finished')
      },5600)
    })
    var _self =  this
    $(document).click(function(event) {
      if (!$(event.target).closest(".rank_holder_user_details, .rank_holder_btn_txt").length) {
        _self.rankHolderPopupClosed()
      }
    });
    if(localStorage.getItem('t')){
      this.loggedinLinkHide = false
    }else{
      this.loggedinLinkHide = true
    }
  },
  methods: {
    rankHolderPopupEnabled(){
      if(!this.isLeaderBoardDone) {
        this.$store.dispatch('getPublicLeaderboardListFun')
          .then(res => {
            this.getPubLeaderboardDetails = this.$store.getters.publicLeaderboardGetters.data;
          })
          .catch(err => {})
        this.isLeaderBoardDone = true;
      }
    },
    rankHolderAnimation() {
      this.rankHolderDetails = true
      $('body').addClass('rankHolderDetailsMain')
      topBannerSlide3 = setTimeout(()=>{
        $('.rank_holder_user_details_animation').addClass('rank_holder_show_content')
      },300)
      topBannerSlide4 = setTimeout(()=>{
        $('.rank_holder_user_details').addClass('overflow_content_show')
      },1500)
    },
    rankHolderPopupClosed(){
      this.rankHolderDetails = false
      $('body').removeClass('rankHolderDetailsMain')
      $('.rank_holder_user_details_animation').removeClass('rank_holder_show_content')
      $('.rank_holder_user_details').removeClass('overflow_content_show')
    },
    getCountryFlag: function(countryCode, type) {
      if (countryCode == null) {
        countryCode = ''
      }
      let countryName = countryCode.toLowerCase()
      let country = this.countryList.filter(item => (item.value) == (countryName) || (item.name) == (countryName));
      if (country && country.length > 0) {
        country = country[0]
        if (type == 'flag') {
          country = `http://567c9b4f06e54c9c9229fe11191a6432.s3.ca-central-1.amazonaws.com/media/country/${country.value}.png`
        } else {
          country = country.name
        }
      } else {
        country = ''
      }
      return country;
    },
    moveNext(){
      this.$refs.example.$fullpage.moveNext(); //Move to the next page
    },
    moveNextAgain(){
      this.$refs.example.$fullpage.moveNext(); //Move to the next page
    },
    setBackgroundImage() {
      var element = document.getElementsByClassName('random_bgimg');
      let x = this.imageIndex;
      let images = this.images;
      let variation_images = this.variation_images;
      if (x < images.length) {
        for(let i =0; i< element.length; i++){
          element[i].style["background-image"] = "url(" + variation_images[x] + ")";
        }
        $('.section_heading_landing').addClass('act_clr' + x);
        $('.quiz_contest_actv_wrp').addClass('act_contest_clr' + x);
        $('.top_rank_holder').addClass('act_contest_clr_of_holders' + x);
        $('.navbar_list_wrp').addClass('act_contest_clr_of_holders' + x);
        setTimeout(() => {
          $('.app-loader.global').hide();
        }, 3000)
      }
    },
    randomImgLoaded() {
      // Multi Color Bg Img Of Section
      var images = ["random_img1", "random_img2", "random_img3", "random_img4", "random_img5", "random_img6"]
      var variation_images = [variation_random_img1, variation_random_img2, variation_random_img3, variation_random_img4, variation_random_img5, variation_random_img6]
      this.variation_images = variation_images;
      this.images = images;
      var size = images.length;
      var x = Math.floor(size * Math.random());
      this.imageIndex = x;
      this.setBackgroundImage();
    },
    // loadToSection(param) {
    //   setTimeout(function() {
    //     if (param != '') {
    //       $('#' + param).removeClass('d-none');

    //       $('body').addClass('enabled');
    //       setTimeout(function(){
    //         $(".first_banner .explore_btn").addClass('actv_explore')
    //       }, 1000)
    //       $('html,body').animate({
    //         scrollTop: $('#' + param).offset().top
    //       }, 'slow');
    //     }
    //   }, 200)
    // },
    // contestPopupEnbaled(){
    //   $(".quiz_contest_popup").removeClass('d-none')
    //   // this.contestPopup = true
    //   setTimeout(()=>{
    //     $(".quiz_contest_popup_wrp").addClass('actv_contest_popup')
    //   },1)
    // },
    handleResize() {
      let browserView = ''
      let windowWidth = window.innerWidth;
      if (windowWidth >= 1120) {
        browserView = 'desktop';
      } else {
        browserView = 'mobile';
      }
      // console.log(this.currentView, browserView);
      if(this.currentView == 'desktop' && browserView == 'mobile' || this.currentView == 'mobile' && browserView == 'desktop'){
        this.$router.go(0);
      }
    },
    handleResizeInit() {
      this.window.width = window.innerWidth;
      if (this.window.width >= 992) {
        this.extralargeWrapperScreen = true;
      } else {
        this.extralargeWrapperScreen = false;
      }
      // console.log(this.homewrpscreen, 'Data');
      if (this.window.width >= 1120) {
        this.homewrpscreen = true;
        this.currentView = 'desktop';
        $('body').addClass('final_slide')
        $('body.final_slide').mCustomScrollbar({
          theme:"inset-3-dark",
          contentTouchScroll:25,
          keyboard:{ scrollType: "stepless" }
        })
      } else {
        this.homewrpscreen = false;
        this.currentView = 'mobile';
        $('.final_slide').mCustomScrollbar('destroy');
      }
    }
  },
  beforeCreate: function() {
    $('body').addClass('home public-routes');
    // this.loadToSection;
  },
  beforeRouteLeave: function(to, from, next) {
    $('.navbar_list_wrp').removeClass('act_contest_clr_of_holders' + this.imageIndex);
    $('.final_slide').mCustomScrollbar('destroy');
    $('body').removeClass('final_slide');
    $('body').removeClass('home public-routes');
    localStorage.removeItem('Explore_Course');
    clearTimeout(actvSlide);
    clearTimeout(actvDots);
    clearTimeout(overFlowVis);
    clearTimeout(beforeLineActv);
    clearTimeout(actvAlertPopup);
    clearTimeout(actvAlertTopLine)
    clearTimeout(topBannerSlide)
    clearTimeout(topBannerSlide1)
    clearTimeout(topBannerSlide2)
    clearTimeout(topBannerSlide3)
    clearTimeout(topBannerSlide4)
    $("body").removeClass('contest_popup_active')
    $('body').removeClass('rankHolderDetailsMain')
    $('.rank_holder_user_details_animation').removeClass('rank_holder_show_content')
    $('.rank_holder_user_details').removeClass('overflow_content_show')
    next();
  },
  beforeMount() {
    this.getCategory;
  },
  created() {
    window.addEventListener('resize', this.handleResize)
    this.handleResizeInit();
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize)
  }
}
